import {ComponentType} from "react";
import {Sentry} from "./Sentry";

// TODO: put this in the tracking library

export function withProfiler(component: ComponentType<any>, {name}: {name: string}) {
    return Sentry.withProfiler(component, {name});
}
